import React, { ReactNode } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

interface RowProps {
  children: ReactNode;
  onLayout?: () => void;
  style?: ViewStyle;
}

export const Row: React.FC<RowProps> = React.memo(
  ({ children, onLayout, style }) => (
    <View onLayout={onLayout} style={[style, grid.row]}>
      {children}
    </View>
  ),
);

interface ColProps {
  children?: ReactNode;
  size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  style?: ViewStyle;
}

export const Col: React.FC<ColProps> = React.memo(
  ({ size, style, children }) => (
    <View style={[grid[`col_${size}`], style]}>{children}</View>
  ),
);

interface GridProps {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}

export const Grid: React.FC<GridProps> = React.memo(({ children, style }) => (
  // eslint-disable-next-line react-native/no-inline-styles
  <View style={[{ flex: 1 }, style]}>{children}</View>
));

const grid = StyleSheet.create({
  col_1: { flex: 8.33 / 100, flexDirection: 'column' },
  col_2: { flex: 16.66 / 100, flexDirection: 'column' },
  col_3: { flex: 25 / 100, flexDirection: 'column' },
  col_4: { flex: 33.33 / 100, flexDirection: 'column' },
  col_5: { flex: 41.66 / 100, flexDirection: 'column' },
  col_6: { flex: 50 / 100, flexDirection: 'column' },
  col_7: { flex: 58.33 / 100, flexDirection: 'column' },
  col_8: { flex: 66.66 / 100, flexDirection: 'column' },
  col_9: { flex: 75 / 100, flexDirection: 'column' },
  col_10: { flex: 83.33 / 100, flexDirection: 'column' },
  col_11: { flex: 91.66 / 100, flexDirection: 'column' },
  col_12: { flex: 100 / 100, flexDirection: 'column' },
  row: {
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'row',
    flexGrow: 0,
    flexWrap: 'wrap',
  },
});
